module.exports = __webpack_public_path__ + "assets/images/close-window.svg";